export default __webpack_public_path__ + "static/media/Mark-5-Suit-07.b8817ae1.jpg";